function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Rectangle_2945",
  x: 0,
  y: 0,
  width: 39,
  height: 39,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_02",
  "data-name": 2,
  transform: "translate(34.5 34.5) rotate(180)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1, 0, 0, -1, 34.5, 34.5)",
  filter: "url(#Rectangle_2945)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2945-2",
  "data-name": "Rectangle 2945",
  width: 30,
  height: 30,
  rx: 5,
  transform: "translate(34.5 34.5) rotate(180)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_689",
  "data-name": "Group 689",
  transform: "translate(5 25) rotate(-90)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2938",
  "data-name": "Rectangle 2938",
  width: 19.994,
  height: 2,
  rx: 1,
  transform: "translate(9) rotate(90)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2940",
  "data-name": "Rectangle 2940",
  width: 19.994,
  height: 2,
  rx: 1,
  transform: "translate(5) rotate(90)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2941",
  "data-name": "Rectangle 2941",
  width: 19.994,
  height: 2,
  rx: 1,
  transform: "translate(1) rotate(90)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2939",
  "data-name": "Rectangle 2939",
  width: 10,
  height: 19.788,
  rx: 2,
  transform: "translate(11 0.212)",
  fill: "#707070"
})));

var SvgVerticalInverse = function SvgVerticalInverse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVerticalInverse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/verticalInverse.9e531ab7.svg";
export { ForwardRef as ReactComponent };